import { CONSTANTS } from '#app/constants/index.ts'
import { useAppHref } from '#app/utils/hosts.ts'

const LegalLink = ({ href, label }: { href: string; label: string }) => (
	<li>
		<a
			href={href}
			className="text-md text-quaternary hover:text-tertiary transition duration-100 ease-linear"
		>
			{label}
		</a>
	</li>
)

export const Footer = () => {
	const year = new Date().getFullYear()
	// The legal documents for this product live on the application host, so from
	// the marketing site these resolve to absolute URLs.
	const cookiesHref = useAppHref('/cookies')
	const privacyHref = useAppHref('/privacy')
	const termsHref = useAppHref('/terms')

	return (
		<footer className="bg-primary py-12">
			<div className="max-w-container mx-auto px-4 md:px-8">
				<div className="flex flex-col items-center gap-6 md:justify-between lg:flex-row-reverse">
					<nav aria-label="Legal">
						<ul className="flex flex-wrap items-center justify-center gap-x-6 gap-y-2">
							<LegalLink href={cookiesHref} label="Cookies" />
							<LegalLink href={privacyHref} label="Privacy Notice" />
							<LegalLink href={termsHref} label="Terms of Service" />
						</ul>
					</nav>
					<p className="text-md text-quaternary">
						© {year} {CONSTANTS.NAME}. All rights reserved.
					</p>
				</div>
			</div>
		</footer>
	)
}
